import Vue from "vue";

import store from './store'

import _ from 'lodash'

import VueRouter from "vue-router";
import Threadis from "./pages/Threadis";
import LandingPage from "./pages/LandingPage";
import AuthCallback from "./pages/AuthCallback";
import NotFoundPage from "./pages/NotFoundPage";
import ComposeSimple from "./pages/app/ComposeSimple";
import Timeline from "./pages/app/Timeline";
import Recent from "./pages/app/Recent";
import Terms from "./pages/statics/Terms";
import Privacy from "./pages/statics/Privacy";
import Static from "./pages/statics/Static";
import AuthStart from "./pages/AuthStart";

import {defaultThreadSettings} from "./store/modules/compose"
import {defaultSettings} from "./store/modules/app"
import Drafts from "./pages/app/Drafts";
import Outbox from "./pages/app/Outbox";

Vue.use(VueRouter)

const routes = [
	{
		path: '/app', component: Threadis,
		children: [
			{path: 'compose', name: 'compose', component: ComposeSimple, meta: {title: 'Compose'}},
			{path: 'drafts', component: Drafts, meta: {title: 'Drafts'}},
			{path: 'outbox', component: Outbox, meta: {title: 'Outbox'}},
			{path: 'recent', component: Recent, meta: {title: 'Recent Tweets'}},
			{
				path: 'timelines', component: Timeline,
				children: [
					{path: 'home', meta: {api: 'home', title: 'Home Timeline'}},
					{path: 'you', meta: {api: 'you', title: 'Your Profile'}},
					{path: 'mentions', meta: {api: 'mentions', title: 'Mentions'}},
					{path: ':screenName', props: true, meta: {api: 'user', title: 'Mentions'}},
					{path: '', redirect: 'home'},
				]
			},
			{path: '', redirect: 'compose'}
		]
	},
	{path: '/callback', component: AuthCallback},
	{path: '/authorizing', component: AuthStart},
	{
		path: '', component: Static, children: [
			{path: '/', component: LandingPage, meta: {title: 'Write great Twitter threads without distraction'}},
			{path: '/terms', component: Terms},
			{path: '/privacy', component: Privacy},
			{path: '/*', component: NotFoundPage},
		]
	},
]

let router = new VueRouter({
	mode: 'history',
	linkActiveClass: 'is-active',
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return {
				selector: to.hash,
				behavior: 'smooth',
			}
		} else if (savedPosition) {
      return savedPosition
		} else {
			return {x: 0, y: 0}
		}
	}
})

// set the document title on each router change
router.beforeEach((to, from, next) => {
	document.title = (to.meta.title ? (to.meta.title + ' | Thread') : 'Thread')
	next()
})

// wait for store to restore before loading the route. This will only hold things up on first load
const waitForStorageToBeReady = async (to, from, next) => {
	// pauses all execution until the store has loaded
	await store.restored
	
	// check app settings
	let newSettings = _.merge({}, defaultSettings, store.state.app.settings)
	if (!_.isEqual(newSettings, store.state.app.settings)) {
		store.commit('replaceSettings', newSettings)
	}
	
	// Here we make sure things loaded from the store are valid
	store.state.compose.threads.forEach((thread, index) => {
		let newSettings = _.merge({}, defaultThreadSettings, thread.settings)
		if (!_.isEqual(thread.settings, newSettings)) {
			store.commit('replaceComposeSettings', {
				index: index,
				data: newSettings
			})
		}
	})
	
	next()
}
router.beforeEach(waitForStorageToBeReady)

export default router
